import axios from 'axios'
import store from '@/store/index'
import router from '@/router'
import { thirdMode } from './index.js'

const service = axios.create({
  baseURL: window.__CONFIG__.VUE_APP_API_URL,
  timeout: 60000, // 请求超时时间
  responseType: 'json',
  headers: {
    'Content-Type': 'application/json'
  },
  withCredentials: true, // 跨域携带cookie
  strictSSL: false,
  changeOrigin: true,
  rejectUnauthorized: true, // add when working with https sites
  requestCert: false, // add when working with https sites
  agent: false // add when working with https sites
})

// 添加请求拦截器，这里面可以配置一下每次请求都需要携带的参数，比如 token，timestamp等等，根据项目自己配置
service.interceptors.request.use(request => {
  if (store.state.token && thirdMode) {
    request.headers.Authorization = 'Bearer ' + store.state.token
  }
  return request
})
service.interceptors.response.use(
  response => {
    /**
       * 判断服务器请求是否成功
       * @method if
       * @param  {[type]} response [description]
       * @return {[type]}          [description]
       */
    const res = response.data

    if (res.code === 401) {
      if (router.currentRoute.name !== 'vendor') {
        router.push({ name: 'vendor', query: { logout: 'logout', msg: res.msg } })
      }
      return Promise.reject(res.msg)
    }

    if (res.code >= 200 && res.code < 300) {
      return res
    } else {
      return Promise.reject('网络异常，请稍后重试')
    }
  },
  error => {
    return Promise.reject(error)
  }
)

export const normalRequest = axios.create()
export default service



// WEBPACK FOOTER //
// ./src/utils/request.js